/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_UsernameInputs */

const de__field_username = /** @type {(inputs: _Field_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer:innenname`)
};

/**

* @param {_Field_UsernameInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_username = /** @type {((inputs?: _Field_UsernameInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_UsernameInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_username(inputs)
});